import { OptionalEnumSchema } from 'notable-common';
import { z } from 'zod';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowRestResponseBodyFormat } from '../rest/shared/bodyFormat.js';
import { FlowBlockType } from '../type.js';
export const FlowMontageOnBaseBlockConfigSchema = z.object({
    apiInstanceId: z.uuid(),
    method: z.enum(['GET', 'POST', 'PUT', 'PATCH', 'DELETE']),
    endpoint: z
        .string()
        .min(1, { message: 'Required - enter the URI path for the OnBase endpoint.' }),
    headers: z
        .array(z.object({
        key: z.string().min(1, { message: 'Header key cannot be empty.' }),
        value: z.string().min(1, { message: 'Header value cannot be empty.' }),
    }))
        .optional(),
    responseBodyFormat: OptionalEnumSchema(FlowRestResponseBodyFormat, FlowRestResponseBodyFormat.AutoDetect),
    body: z.string().optional(),
});
export const FlowMontageOnBaseBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.MontageOnBase),
    config: FlowMontageOnBaseBlockConfigSchema,
});
//# sourceMappingURL=config.js.map